/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LivekitTokenRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  livekitTokenRequest: components.LivekitTokenRequest;
};

/** @internal */
export const LivekitTokenRequest$inboundSchema: z.ZodType<
  LivekitTokenRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  LivekitTokenRequest: components.LivekitTokenRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "LivekitTokenRequest": "livekitTokenRequest",
  });
});
/** @internal */
export type LivekitTokenRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  LivekitTokenRequest: components.LivekitTokenRequest$Outbound;
};

/** @internal */
export const LivekitTokenRequest$outboundSchema: z.ZodType<
  LivekitTokenRequest$Outbound,
  z.ZodTypeDef,
  LivekitTokenRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  livekitTokenRequest: components.LivekitTokenRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    livekitTokenRequest: "LivekitTokenRequest",
  });
});

export function livekitTokenRequestToJSON(
  livekitTokenRequest: LivekitTokenRequest,
): string {
  return JSON.stringify(
    LivekitTokenRequest$outboundSchema.parse(livekitTokenRequest),
  );
}
export function livekitTokenRequestFromJSON(
  jsonString: string,
): SafeParseResult<LivekitTokenRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LivekitTokenRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LivekitTokenRequest' from JSON`,
  );
}
